<template>
    <ElPopover
        :visible-arrow="visibleArrow"
        :popper-class="popperClassComputed"
        :trigger="trigger"
        v-bind="$attrs"
        :width="width"
        v-on="$listeners"
    >
        <template #reference>
            <slot name="reference" />
        </template>
        <slot />
    </ElPopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Popover as ElPopover } from 'element-ui'

/* Props */
const props = withDefaults(
    defineProps<{
        visibleArrow?: boolean
        popperClass?: string
        trigger?: string
        width?: string | number
    }>(),
    {
        visibleArrow: true,
        popperClass: '',
        trigger: 'hover',
        width: 'auto'
    }
)

/* Computed */
const popperClassComputed = computed(() => {
    let composed = 'redesign-popover'

    if (props.popperClass) {
        composed += ` ${props.popperClass}`
    }

    if (props.visibleArrow) {
        composed += ' has-arrow'
    }

    return composed
})
</script>

<style lang="scss">
.el-popover.redesign-popover {
    @apply py-2 px-3 rounded;
    background: var(--secondaryBgColor-color);

    &:not(.has-arrow) {
        &[x-placement^=bottom] {
            @apply mt-2 #{!important};
        }

        &[x-placement^=top] {
            @apply mb-2 #{!important};
        }
    }
}
</style>
